module.exports = __webpack_public_path__ + "img/image1.59f5da8b.jpg";